<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="card">
    <div class="body">
    <div class="col-lg-12">
      <exercises ref="exercise_child" :exercise="exercise" :engine="engine"></exercises>
      <br>
      <ValidationObserver ref="formValidation">
      <div class="row">
          <div class="col-md-12"> <strong>Configuracion</strong>
              <div class="custom-control custom-checkbox">
                Tipo motor<select class="form-control" v-model="configuration.TIPO_MOTOR">
                  <option value="0">(0) Copiar</option>
                  <option value="1">(1) Identificar</option>
                  <option value="2">(2) Trazar</option>
                  <option value="3">(3) Calcular</option>
                </select>
              </div>
          </div>
      </div>
      <br>
      <hr>
      <b-row>
        <b-col  style="text-align:center">
          <strong>Operaciones del ejercicio</strong>
          <b-button v-if="arrayEleOperation.length > 1" @click="removeArrayEleOperation()" class="btn btn-danger ml-2" size="sm">-</b-button>
          <b-button @click="addArrayEleOperation()" class="btn btn-primary ml-2" size="sm">+</b-button>
        </b-col>
      </b-row>
      <div>
        <div v-for="(operation, index) in arrayEleOperation" v-bind:key="index">
          <b-row class="justify-content-md-center" style="margin-bottom: 10px">
              <b-col class="p-0 m-0">
                <div class="custom-control custom-checkbox">
                  Tipo Actividad<select class="form-control" v-model="arrayEleOperation[index].ACTIVIDAD">
                    <!-- MOTOR 0 Copiar-->
                    <option v-if="parseInt(configuration.TIPO_MOTOR)===0" value="0">(0) Copiar: Copia</option>
                    <option v-if="parseInt(configuration.TIPO_MOTOR)===0" value="1">(1) Copiar: Traslación</option>
                    <option v-if="parseInt(configuration.TIPO_MOTOR)===0" value="2">(2) Copiar: Simétrico vertical</option>
                    <option v-if="parseInt(configuration.TIPO_MOTOR)===0" value="3">(3) Copiar: Simétrico horizontal</option>
                    <option v-if="parseInt(configuration.TIPO_MOTOR)===0" value="4">(4) Copiar: Redimensión</option>
                    <!-- MOTOR 1 Identificar-->
                    <option v-if="parseInt(configuration.TIPO_MOTOR)===1" value="5">(5) Identificar: Contar figuras</option>
                    <option v-if="parseInt(configuration.TIPO_MOTOR)===1" value="6">(6) Identificar: Identificar figura</option>
                    <option v-if="parseInt(configuration.TIPO_MOTOR)===1" value="7">(7) Identificar: Discriminar (redibujar) figura</option>
                    <!-- MOTOR 2 Trazar-->
                    <option v-if="parseInt(configuration.TIPO_MOTOR)===2" value="8">(8) Trazar: Con ordenes definidas</option>
                    <option v-if="parseInt(configuration.TIPO_MOTOR)===2" value="9">(9) Trazar: Completar una figura</option>
                    <option v-if="parseInt(configuration.TIPO_MOTOR)===2" value="10">(10) Trazar: Calcar una figura</option>
                    <!-- MOTOR 3 Calcular-->
                    <option v-if="parseInt(configuration.TIPO_MOTOR)===3" value="11">(11) Calcular: Perímetros</option>
                    <option v-if="parseInt(configuration.TIPO_MOTOR)===3" value="12">(12) Calcular: Áreas</option>
                    <option v-if="parseInt(configuration.TIPO_MOTOR)===3" value="13">(13) Calcular: Grados</option>
                  </select>
                </div>
              </b-col>
              <b-col>
                <div class="custom-control custom-checkbox">
                  Tipo geoplano<select class="form-control" v-model="arrayEleOperation[index].TIPO_GEOPLANO">
                    <option value="0">Cuadrangular</option>
                    <option value="1">Circular</option>
                  </select>
                </div>
              </b-col>
              <b-col>
                <div class="custom-control custom-checkbox">
                  Filas <div>
                    <b-form-input type="text" v-model="arrayEleOperation[index].FILAS" />
                  </div>
                </div>
              </b-col>
              <b-col>
                <div class="custom-control custom-checkbox">
                  Columnas <div>
                    <b-form-input type="text" v-model="arrayEleOperation[index].COLUMNAS" />
                  </div>
                </div>
              </b-col>
              <b-col v-if="parseInt(arrayEleOperation[index].ACTIVIDAD)===11
              || parseInt(arrayEleOperation[index].ACTIVIDAD)===12
              || parseInt(arrayEleOperation[index].ACTIVIDAD)===13">
                <div class="custom-control custom-checkbox">
                  Respuesta <div>
                    <b-form-input type="text" v-model="arrayEleOperation[index].RESPUESTA" />
                  </div>
                </div>
              </b-col>
              <b-col v-if="parseInt(arrayEleOperation[index].ACTIVIDAD)===5 || parseInt(arrayEleOperation[index].ACTIVIDAD)===6">
                <div class="custom-control custom-checkbox">
                  Figuras correctas <div>
                    <!-- Separados por coma la posición de todas las figuras del geoplano que son correctas en el caso de la actividad  Identificar: Identificar figura -->
                    <b-form-input type="text" v-model="arrayEleOperation[index].CORRECTAS" placeholder="Separadas por comas"/>
                  </div>
                </div>
              </b-col>
              <b-col v-if="parseInt(arrayEleOperation[index].ACTIVIDAD)===4">
                <div class="custom-control custom-checkbox">
                  Redimensión <div>
                    <b-form-input type="number" v-model="arrayEleOperation[index].REDIMENSION" />
                  </div>
                </div>
              </b-col>
              <b-col v-if="parseInt(arrayEleOperation[index].ACTIVIDAD)===1">
                <div class="custom-control custom-checkbox">
                  Desplazamiento <div>
                    <!-- Separados por comas las coordenadas X,Y de un desplazamiento en actividad de desplazamiento -->
                    <b-form-input type="number" v-model="arrayEleOperation[index].DESPLAZAMIENTO" />
                  </div>
                </div>
              </b-col>
          </b-row>
          <b-row class="justify-content-md-center" style="margin-bottom: 10px">
              <b-col md="6">
                <label>Geoplano Modelo</label>
                <!--<ValidationProvider rules="required" v-slot="{ errors }">-->
                  <div class="col-md-12 d-inline-flex align-items-center">
                    <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="arrayEleOperation[index].GEOPLANOS_ID_MODELO !== null && arrayEleOperation[index].GEOPLANOS_ID_MODELO !== 0"
                        @click="openResourceWithParam('geoplanos', arrayEleOperation[index].GEOPLANOS_ID_MODELO)"/>
                    <input type="text" v-model="arrayEleOperation[index].GEOPLANOS_NOMBRE_MODELO"
                      disabled class="form-control" />
                    <searchgeoplanos class="pl-2"
                      v-bind:idModal="'mdlSearchGeoplanos1_'+index"
                      v-on:selected="onGeoplano($event, index, 1)">
                    </searchgeoplanos>
                  </div>
                  <!--<span class="validation-error">{{ errors[0] }}</span>
                </ValidationProvider>-->
              </b-col>
              <b-col md="6">
                <label>Geoplano Respuesta</label>
                <div class="col-md-12 d-inline-flex align-items-center">
                  <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="arrayEleOperation[index].GEOPLANOS_ID_RESPUESTA !== null && arrayEleOperation[index].GEOPLANOS_ID_RESPUESTA !== 0"
                        @click="openResourceWithParam('geoplanos', arrayEleOperation[index].GEOPLANOS_ID_RESPUESTA)"/>
                  <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="arrayEleOperation[index].GEOPLANOS_ID_RESPUESTA !== null" @click="cleanSelection(index, 'NOMBRE_RESPUESTA')"/>
                  <input type="text" v-model="arrayEleOperation[index].GEOPLANOS_NOMBRE_RESPUESTA"
                    disabled class="form-control" />
                  <searchgeoplanos class="pl-2"
                    v-bind:idModal="'mdlSearchGeoplanos2_'+index"
                    v-on:selected="onGeoplano($event, index, 2)">
                  </searchgeoplanos>
                </div>
              </b-col>
          </b-row>
          <b-row class="justify-content-md-center" style="margin-bottom: 10px">
              <b-col md="6">
                <label>Consigna escrita</label>
                <div class="col-md-12 d-inline-flex align-items-center">
                  <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="arrayEleOperation[index].CONSIGNAS_ESCRITAS_ID !== null && arrayEleOperation[index].CONSIGNAS_ESCRITAS_ID !== 0"
                        @click="openResourceWithParam('writteninstructions', arrayEleOperation[index].CONSIGNAS_ESCRITAS_ID)"/>
                  <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="arrayEleOperation[index].CONSIGNAS_ESCRITAS_ID !== null" @click="cleanSelection(index, 'CONSIGNAS_ESCRITAS_TEXTO')"/>
                  <input type="text" v-bind:value="getTranslation(arrayEleOperation[index].CONSIGNAS_ESCRITAS_TEXTOS)"
                    disabled class="form-control" />
                  <searchwritteninstructions class="pl-2"
                    v-bind:idModal="'mdlSearchWrittenInstructions_'+index"
                    v-on:selected="onWrittenInstructions($event, index)">
                  </searchwritteninstructions>
                </div>
              </b-col>
              <b-col>
                <label>Consigna oral</label>
                <div class="col-md-12 d-inline-flex align-items-center">
                  <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="arrayEleOperation[index].CONSIGNAS_ORALES_ID !== null && arrayEleOperation[index].CONSIGNAS_ORALES_ID !== 0"
                        @click="openResourceWithParam('writtenorals', arrayEleOperation[index].CONSIGNAS_ORALES_ID)"/>
                  <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="arrayEleOperation[index].CONSIGNAS_ORALES_ID !== null" @click="cleanSelection(index, 'CONSIGNAS_ORALES')"/>
                  <audio :src="getTranslation(arrayEleOperation[index].CONSIGNAS_ORALES_FICHERO)" controls="controls"
                              style="width:100%" type="audio/mpeg" preload="preload" v-if="arrayEleOperation[index].CONSIGNAS_ORALES_ID !== null">
                  </audio>
                  <span v-if="arrayEleOperation[index].CONSIGNAS_ORALES_ID === null">Sin audio</span>
                  <searchwrittenorals class="pl-2"
                    v-bind:idModal="'mdlSearchWrittenOrals_'+index"
                    v-on:selected="onOralInstructions($event, index)">
                  </searchwrittenorals>
                </div>
              </b-col>
          </b-row>
          <hr/>
        </div>
      </div>
      <br>
      <b-row>
        <b-col class="text-center">
          <button v-on:click="saveStorage" :disabled="arrayEleOperation.length < 1" class="btn btn-info btn-lg">
          Guardar
        </button>
        </b-col>
      </b-row>
      </ValidationObserver>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import { ValidationObserver, extend } from 'vee-validate';
// import { ValidationProvider } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import exercises from '../../exercises/exercise.vue';
import engineMixin from '../../../../mixins/engine';
import searchwritteninstructions from '../../writteninstructions/SearchWrittenInstructions.vue';
import searchwrittenorals from '../../writtenorals/SearchWrittenOrals.vue';
import searchgeoplanos from '../../geoplanos/SearchGeoplanos.vue';
import translationMixin from '../../../../mixins/translation';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});

export default {
  props: {
    engine: Number,
    exercise: Object,
    type: String,
  },
  mixins: [engineMixin, translationMixin],
  components: {
    exercises,
    // ValidationProvider,
    ValidationObserver,
    searchwritteninstructions,
    searchwrittenorals,
    searchgeoplanos,
  },
  data() {
    return {
      arrayEleOperation: [],
      // Mapear con los campos de la tabla GEOPLANOS_CONF
      configuration: {
        ID: -1,
        TIPO_MOTOR: '0',
        EJERCICIOS_ID: -1, //
      },
    };
  },
  methods: {
    /**
    * @method cleanGeoplano
    * @description Limpia la Modelo
    */
    cleanSelection(pos, tipo) {
      switch (tipo) {
        case 'NOMBRE_RESPUESTA':
          this.arrayEleOperation[pos].GEOPLANOS_ID_RESPUESTA = null;
          this.arrayEleOperation[pos].GEOPLANOS_NOMBRE_RESPUESTA = null;
          break;
        case 'CONSIGNAS_ESCRITAS_TEXTO':
          this.arrayEleOperation[pos].CONSIGNAS_ESCRITAS_ID = null;
          this.arrayEleOperation[pos].CONSIGNAS_ESCRITAS_TEXTOS = [];
          break;
        case 'CONSIGNAS_ORALES':
          this.arrayEleOperation[pos].CONSIGNAS_ORALES_ID = null;
          this.arrayEleOperation[pos].CONSIGNAS_ORALES_NOMBRE = null;
          this.arrayEleOperation[pos].CONSIGNAS_ORALES_FICHERO = [];
          break;
        case 'CONSIGNAS_ORALES_REFUERZO':
          this.arrayEleOperation[pos].CONSIGNAS_ORALES_ID_REFUERZO = null;
          this.arrayEleOperation[pos].CONSIGNAS_ORALES_REF_NOMBRE = null;
          this.arrayEleOperation[pos].CONSIGNAS_ORALES_REF_FICHERO = [];
          break;
        default:
          break;
      }
    },
    removeArrayEleOperation() {
      this.arrayEleOperation.pop();
    },
    addArrayEleOperation() {
      this.arrayEleOperation.push({
        POSICION: this.arrayEleOperation.length + 1,
        ACTIVIDAD: 0,
        TIPO_GEOPLANO: '0', // TODO: Borrar? ya estan en la tabla GEOPLANOS (sin _ELE)
        FILAS: 5, // TODO: Borrar? ya estan en la tabla GEOPLANOS (sin _ELE)
        COLUMNAS: 5, // TODO: Borrar? ya estan en la tabla GEOPLANOS (sin _ELE)
        RESPUESTA: null,
        CORRECTAS: null,
        REDIMENSION: null,
        DESPLAZAMIENTO: null,
        CONSIGNAS_ESCRITAS_ID: null,
        CONSIGNAS_ESCRITAS_TEXTOS: [], // Display only ES
        CONSIGNAS_ORALES_ID: null,
        CONSIGNAS_ORALES_NOMBRE: '', // Display only
        CONSIGNAS_ORALES_FICHERO: [], // Display only
        CONSIGNAS_ORALES_ID_REFUERZO: null,
        CONSIGNAS_ORALES_REF_NOMBRE: '', // Display only
        CONSIGNAS_ORALES_REF_FICHERO: [], // Display only
        GEOPLANOS_ID_MODELO: null,
        GEOPLANOS_NOMBRE_MODELO: null,
        GEOPLANOS_ID_RESPUESTA: null,
        GEOPLANOS_NOMBRE_RESPUESTA: null,
      });
    },
    async getMotorData(id) {
      this.loading = true;

      try {
        const response = await this.axios.get('geometry/getgeometry', {
          params: {
            ejercicios_id: id,
          },
        });

        this.configuration = response.data.config;
        response.data.elements.forEach((element) => {
          this.arrayEleOperation.push({
            POSICION: element.POSICION,
            ACTIVIDAD: element.ACTIVIDAD,
            TIPO_GEOPLANO: element.TIPO_GEOPLANO,
            FILAS: element.FILAS,
            COLUMNAS: element.COLUMNAS,
            RESPUESTA: element.RESPUESTA,
            CORRECTAS: element.CORRECTAS,
            REDIMENSION: element.REDIMENSION,
            DESPLAZAMIENTO: element.DESPLAZAMIENTO,
            GEOPLANOS_CONF_ID: element.GEOPLANOS_CONF_ID,
            CONSIGNAS_ESCRITAS_ID: element.CONSIGNAS_ESCRITAS_ID,
            CONSIGNAS_ESCRITAS_TEXTOS: element.CONSIGNAS_ESCRITAS_TEXTOS,
            CONSIGNAS_ORALES_ID: element.CONSIGNAS_ORALES_ID,
            CONSIGNAS_ORALES_FICHERO: element.CONSIGNAS_ORALES_FICHERO,
            CONSIGNAS_ORALES_ID_REFUERZO: element.CONSIGNAS_ORALES_ID_REFUERZO,
            CONSIGNAS_ORALES_REF_FICHERO: element.CONSIGNAS_ORALES_REF_FICHERO,
            GEOPLANOS_ID_MODELO: element.GEOPLANOS_ID_MODELO,
            GEOPLANOS_NOMBRE_MODELO: element.GEOPLANOS_NOMBRE_MODELO,
            GEOPLANOS_ID_RESPUESTA: element.GEOPLANOS_ID_RESPUESTA,
            GEOPLANOS_NOMBRE_RESPUESTA: element.GEOPLANOS_NOMBRE_RESPUESTA,
          });
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el ejercicio', { type: 'warning' });
      }

      this.loading = false;
    },
    /**
    * @method onWrittenInstructions
    * @description Al buscar una consigna escrita
    */
    onWrittenInstructions(itemSelected, index) {
      this.arrayEleOperation[index].CONSIGNAS_ESCRITAS_TEXTOS = itemSelected.TEXTOS;
      this.arrayEleOperation[index].CONSIGNAS_ESCRITAS_ID = itemSelected.ID;
      this.$root.$emit('bv::hide::modal', `mdlSearchWrittenInstructions_${index}`);
    },
    /**
    * @method onOralInstructions
    * @description Al buscar una consigna oral
    */
    onOralInstructions(itemSelected, index) {
      this.arrayEleOperation[index].CONSIGNAS_ORALES_NOMBRE = itemSelected.NOMBRE;
      this.arrayEleOperation[index].CONSIGNAS_ORALES_FICHERO = itemSelected.FICHERO;
      this.arrayEleOperation[index].CONSIGNAS_ORALES_ID = itemSelected.ID;
      this.$root.$emit('bv::hide::modal', `mdlSearchWrittenOrals_${index}`);
    },
    onOralInstructionsRef(itemSelected, index) {
      this.arrayEleOperation[index].CONSIGNAS_ORALES_REF_NOMBRE = itemSelected.NOMBRE;
      this.arrayEleOperation[index].CONSIGNAS_ORALES_REF_FICHERO = itemSelected.FICHERO;
      this.arrayEleOperation[index].CONSIGNAS_ORALES_ID_REFUERZO = itemSelected.ID;
      this.$root.$emit('bv::hide::modal', `mdlSearchWrittenOralsRef_${index}`);
    },
    /**
    * @method onGeoplano
    * @description Al seleccionar un geoplano
    */
    onGeoplano(itemSelected, index, geoplano) {
      if (geoplano === 1) {
        // Modelo
        this.arrayEleOperation[index].GEOPLANOS_ID_MODELO = itemSelected.ID;
        this.arrayEleOperation[index].GEOPLANOS_NOMBRE_MODELO = itemSelected.NOMBRE;
        this.$root.$emit('bv::hide::modal', `mdlSearchGeoplanos1_${index}`);
      } else {
        // Respuesta
        this.arrayEleOperation[index].GEOPLANOS_ID_RESPUESTA = itemSelected.ID;
        this.arrayEleOperation[index].GEOPLANOS_NOMBRE_RESPUESTA = itemSelected.NOMBRE;
        this.$root.$emit('bv::hide::modal', `mdlSearchGeoplanos2_${index}`);
      }
    },
  },
  async mounted() {
    if (this.exercise !== null && (this.exercise.ID !== null && this.exercise.ID !== undefined)) {
      await this.getMotorData(this.exercise.ID);
    }
    // Read from storage data
    this.readFromStorage(this.type);
    this.updatedNumOperation();
  },
};
</script>
